
import { OrderListEffects } from './orders.effects';


export const ordersEffects = [
    OrderListEffects
];

export {orderListReducer as ordersReducer} from './state/order-list.reducer';
